import type {
  IChatSettings,
  IProjectList,
  IUserProfile,
} from "@frontend-shared/types";
import { createContext } from "react";

export interface ICustomSession {
  user: IUserProfile;
}

export interface IAuthContext {
  isLoading: boolean;
  user: IUserProfile | null;
  isPersonalProject: boolean;
  projects: IProjectList | null;
  currentProjectUuid: string | null;
  projectPermissions: Record<string, string[]> | null;
  chatSettings: IChatSettings | null;
  signOut: () => Promise<void>;
  getUser: () => void;
  onCurrentProjectChange: (uuid: string) => void;
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined);
